export default function ErrorLog(props) {
  const logObject = {
    message_type: props.message_type,
    dashboard_url: window.location.href,
    dashboard_name: 'RSV_UI',
    error_details: props.error_details.toString(),
    user_name:
      props.user === undefined || props.user === ''
        ? ''
        : `user: ${props.user?.username}, id:${props.user?.userid}`,
    email:
      props.user === undefined || props.user === ''
        ? ''
        : `email: ${props.user?.email}`,
    application_name: 'rsv',
  }

  const clientConfigApiDomain = process.env.REACT_APP_BACKEND_BASE_URL
  const apiUrl = `${clientConfigApiDomain}/errorlogs/`;

  const NAMESPACE_OPTUM_REACTOR = process.env.REACT_APP_NAMESPACE_OPTUM_REACTOR;

  if(props.message_type == 'ReactorCXScriptError'){
    const reactorError = async () => {
      try {
      let response = await fetch(apiUrl, {
        method: 'post',
        body: JSON.stringify(logObject),
        headers: { 'Content-Type': 'text/plain', Accept: 'application/json', },   
        credentials: 'include',
      })
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      let data = await response.json();
    }
    catch(e){
      console.log('Reactor error: '+ e);
    }
   };
   reactorError();
  }
  else{
    const custom_data_object = {"namespace": NAMESPACE_OPTUM_REACTOR, "LogObject":logObject }
    if (typeof window !== 'undefined' && window.hasOwnProperty("Rakanto") && window.Rakanto.hasOwnProperty('event')) {
      window.Rakanto.event("sendCustomData", custom_data_object);
      window.Rakanto.event('viewLoaded');
    }
  }
}
